<template>
	<div class="batch-import-task-page page-layout">
		<gc-header headerData="deviceGroup">
			<template #ops>
				<el-button
					v-has="'monitor:imei:group:insert'"
					type="primary"
					@click="
						selectFormValues = null
						groupModalVisible = true
					"
				>
					新增设备组
				</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleQuerySearch"
					@reset="handleQueryReset"
				/>
				<gc-column-setting
					storageKey="localcolumn-om-device-group"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table
					border
					showPage
					:columns="columnList"
					:table-data="tableData"
					:current-page.sync="pagination.currentPage"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					@current-page-change="handleCurrentPageChange"
					@size-change="handlePageSizeChange"
				></gc-table>
			</div>
		</div>
		<OperateDeviceGroupModal
			v-if="groupModalVisible"
			:deviceTypeListOptions="deviceTypeListOptions"
			:manufacturerListOptions="manufacturerListOptions"
			:formValues="selectFormValues"
			@close-modal="handleCloseModal"
		/>
	</div>
</template>

<script>
import {
	apiGetDeviceGroupPageList,
	apiUpdateDeviceGroupStatus,
	apiDeleteDeviceGroup,
} from '@/apis/communicationModelManage.api'
import { apiGetDeviceTypeImeiList } from '@/apis/account.api'
import { apiManufacturerList } from '@/apis/factory.api'
import OperateDeviceGroupModal from './components/OperateDeviceGroupModal'

export default {
	name: 'deviceGroup',
	components: { OperateDeviceGroupModal },
	data() {
		return {
			form: {
				deviceGroupName: null,
				manufacturerId: null,
				deviceTypeIdList: null,
			},
			columns: [
				{
					key: 'deviceGroupName',
					name: '设备组名称',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'manufacturerName',
					name: '厂商',
					tooltip: true,
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
					tooltip: true,
				},
				{
					key: 'status',
					name: '状态',
					render: (h, row) => {
						return h(
							'span',
							{ class: row.status === 0 ? 'dot-error' : 'dot-success' },
							row.status === 1 ? '启用' : '禁用',
						)
					},
				},
				{
					key: 'createStaffName',
					name: '创建人',
				},
				{
					key: 'remarks',
					name: '备注',
					tooltip: true,
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 240,
					render: (h, row) => {
						return h('div', null, [
							row.manufacturerId === this.manufacturerId && this.$has('monitor:imei:group:update')
								? h(
										'el-button',
										{
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleOperate(row, 'update'),
											},
										},
										'修改',
								  )
								: null,
							row.manufacturerId === this.manufacturerId &&
							row.status === 1 &&
							this.$has('monitor:imei:group:update')
								? h(
										'el-button',
										{
											style: { color: '#e5662e' },
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleOperate(row, 'status'),
											},
										},
										'禁用',
								  )
								: null,
							row.manufacturerId === this.manufacturerId &&
							row.status === 0 &&
							this.$has('monitor:imei:group:update')
								? h(
										'el-button',
										{
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleOperate(row, 'status'),
											},
										},
										'启用',
								  )
								: null,
							row.manufacturerId === this.manufacturerId && this.$has('monitor:imei:group:delete')
								? h(
										'el-button',
										{
											style: { color: '#e5662e' },
											props: { type: 'text', size: 'medium' },
											on: {
												click: () => this.handleOperate(row, 'delete'),
											},
										},
										'删除',
								  )
								: null,
							h(
								'el-button',
								{
									props: { type: 'text', size: 'medium' },
									on: {
										click: () => this.handleOperate(row, 'detail'),
									},
								},
								'详情',
							),
						])
					},
				},
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			groupModalVisible: false,
			manufacturerListOptions: [],
			deviceTypeListOptions: [],
			selectFormValues: null,
		}
	},

	created() {
		this.queryDeviceTypeList()
		this.queryManufacturerList()
		this.queryTableDataPageList()
	},

	methods: {
		async queryManufacturerList() {
			const data = await apiManufacturerList({ current: 1, size: 1000 })
			this.manufacturerListOptions = (data.records || []).map(m => {
				return {
					value: m.manufacturerId,
					label: m.manufacturerName,
				}
			})
		},

		async queryDeviceTypeList() {
			const data = await apiGetDeviceTypeImeiList(this.tenantId)
			this.deviceTypeListOptions = (data.records || []).map(item => {
				return {
					value: item.deviceTypeId,
					label: item.deviceTypeName,
				}
			})
		},

		async queryTableDataPageList() {
			this.loading = true
			const searchParams = {
				...this.form,
				manufacturerId: this.form.manufacturerId || this.manufacturerId,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetDeviceGroupPageList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleOperate(rowItem, type) {
			if (type === 'detail') {
				this.$router.push({
					path: '/communication-model-manage/device-group/details',
					query: {
						id: rowItem.id,
					},
				})
			} else if (type === 'status') {
				this.handleUpdateDeviceGroupStatus({ ...rowItem, status: rowItem.status === 1 ? 0 : 1 })
			} else if (type === 'delete') {
				this.handleDeleteDeviceGroup(rowItem)
			} else if (type === 'update') {
				this.selectFormValues = rowItem
				this.groupModalVisible = true
			}
		},

		/**
		 * 设备组删除
		 * @param {*} param0
		 */
		async handleDeleteDeviceGroup({ id, manufacturerId }) {
			await this.$confirm('你确定要删除该设备组，删除后不可撤销，请确认！')
			await apiDeleteDeviceGroup({ deviceGroupId: id, manufacturerId })
			this.$message.success('操作成功')
			this.handleQueryReset()
		},

		/**
		 * 设备组状态变更
		 * @param {*} param0
		 */
		async handleUpdateDeviceGroupStatus({ id, manufacturerId, status }) {
			await this.$confirm(status === 1 ? '确认启用该设备组？' : '确认禁用该设备组？')
			await apiUpdateDeviceGroupStatus({ id, manufacturerId, status })
			this.$message.success('操作成功')
			this.handleQueryReset()
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryTableDataPageList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				this.form[key] = null
			}
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleCloseModal(refresh) {
			this.groupModalVisible = false
			if (refresh) {
				this.handleQueryReset()
			}
		},
	},

	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		filterFields() {
			return [
				{
					prop: 'deviceGroupName',
					label: '设备组名称',
					type: 'input',
				},
				{
					prop: 'manufacturerId',
					label: '厂商',
					type: 'select',
					props: {
						searchOption: this.manufacturerListOptions,
						filterable: true,
						needAllForSearch: true,
					},
					hidden: this.manufacturerId !== 0,
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.deviceTypeListOptions,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
				},
			].filter(item => !item.hidden)
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
</style>
